import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { CreateEditService } from '@core/http/create-edit-service';
import { HttpMesageHandlerService } from '@core/service/http-mesage-handler';
import { UserService } from '@core/http/table-data-services/User.service';
import { FormatMobilePipe } from '@core/pipes/format-mobile.pipe';
import { HttpErrorResponse } from '@angular/common/http';

export interface TutoradoProfileDialogData {
  idUsuario: string;
}

@Component({
  selector: 'app-tutorado-profile-dialog',
  standalone: true,
  imports: [CommonModule, NgIf, MatDialogModule, MatIcon, MatButtonModule, FormatMobilePipe],
  templateUrl: './tutorado-profile-dialog.component.html',
  styleUrl: './tutorado-profile-dialog.component.scss'
})
export class TutoradoProfileDialogComponent implements OnInit {
  loading = true;

  // data del paciente (viene de getPacienteByUsuarioId)
  p: any = null;

  // imagen base64 final (con prefijo)
  imageSrc: string = 'assets/images/paciente.png';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TutoradoProfileDialogData,
    private dialogRef: MatDialogRef<TutoradoProfileDialogComponent>,
    private createEditService: CreateEditService,
    private userService: UserService,
    private httpMsg: HttpMesageHandlerService
  ) {}

  ngOnInit(): void {
    const idUsuario = (this.data?.idUsuario ?? '').trim();
    if (!idUsuario) {
      this.loading = false;
      return;
    }

    // 1) Cargar datos completos del paciente por idUsuario
    this.createEditService.getPacienteByUsuarioId(idUsuario).subscribe({
      next: (res: any) => {
        const raw = res?.data ?? res ?? null;
        const obj = Array.isArray(raw) ? raw[0] : raw;

        this.p = obj ?? null;

        // 2) Cargar imagen (si el endpoint existe)
        this.loadImage(idUsuario);

        this.loading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.httpMsg.handleMsg(err);
      }
    });
  }

  private loadImage(idUsuario: string): void {
    this.userService.getUserImageBase64(idUsuario).subscribe({
      next: (img: string) => {
        const normalized = (img ?? '').trim();
        this.imageSrc = normalized ? normalized : 'assets/images/paciente.png';
      },
      error: () => {
        this.imageSrc = 'assets/images/paciente.png';
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  getNombre(): string {
    const n = this.p?.nombres ?? '';
    const a1 = this.p?.primerApellido ?? '';
    const a2 = this.p?.segundoApellido ?? '';
    return `${n} ${a1} ${a2}`.replace(/\s+/g, ' ').trim();
  }

  getGenero(): string {
    const g = (this.p?.genero ?? '').toString().toUpperCase();
    if (g === 'F') return 'FEMENINO';
    if (g === 'M') return 'MASCULINO';
    return g || 'N/D';
  }
}
